<template>
  <div class="voucher-container">
    <div class="wizard-section">
      <div class="voucher-image-section">
        <!-- <img
          src="../images/sample-image.jpg"
          alt="Voucher"
          class="img-fluid voucher-image"
        > -->
        <img
          v-show="imageLoaded"
          :src="styleStore.voucherImageUrl"
          alt="Voucher"
          class="img-fluid voucher-image"
          @load="imageLoaded = true"
          @error="imageLoaded = false"
        >
      </div>
      <div class="voucher-selection">
        <div class="row">
          <div class="col-md-6">
            <h3 class="mb-2">
              <strong>Voucher Value</strong>
            </h3>
            <b-form-group
              label="Select Voucher Value:"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="formStore.formData.voucherValue"
                :options="valueOptions"
                size="lg"
                class="voucher-select"
              >
                <template #first>
                  <option
                    :value="null"
                    disabled
                  >
                    Select amount...
                  </option>
                </template>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <h3 class="mb-2">
              <strong>Quantity</strong>
            </h3>

            <b-form-group
              label="Select Quantity:"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="formStore.formData.quantity"
                :options="quantityOptions"
                size="lg"
                class="quantity-select"
              >
                <template #first>
                  <option
                    :value="null"
                    disabled
                  >
                    Select quantity...
                  </option>
                </template>
              </b-form-select>
            </b-form-group>
          </div>
        </div>

        <!-- <div class="split-section mt-2">
          <h3 class="mb-2">
            <strong>Split with Friends</strong>
          </h3>
          <p class="text-muted">
            Payment will be divided equally, and they will receive an email to
            contribute to the voucher.
          </p>
          <b-form-radio-group
            v-model="formStore.formData.splitWithFriends"
            :options="splitOptions"
            buttons
            button-variant="outline-primary"
            class="mt-2"
          />
        </div> -->

        <div class="text-right mt-4">
          <b-button
            variant="primary"
            size="lg"
            :disabled="
              !formStore.formData.voucherValue || !formStore.formData.quantity
            "
            @click="handleContinueClick"
          >
            Continue
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { useStyleStore } from "../stores/styleStore";

export default {
  data() {
    return {
      formStore: useFormStore(),
      styleStore: useStyleStore(),
      imageLoaded: true,
      quantityOptions: Array.from({ length: 25 }, (_, i) => ({
        value: i + 1,
        text: (i + 1).toString(),
      })),
      splitOptions: [
        { text: "OFF", value: false },
        { text: "ON", value: true },
      ],
    };
  },
  computed: {
    valueOptions() {
      const styleStore = useStyleStore();
      const currency = styleStore.storeInfo?.currency || "";
      return [10, 25, 50, 75, 100, 150, 170, 200, 250, 300, 350, 400, 450, 500].map((value) => ({
        value: value,
        text: `${currency}${value}`,
      }));
    },
  },
  watch: {
    "formStore.formData": {
      deep: true,
      handler() {
      },
    },
  },
  methods: {
  handleContinueClick() {
    this.formStore.nextStep();

    // Only scroll to top if screen width is <= 768px (common mobile breakpoint)
    if (window.innerWidth <= 768) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
};
</script>

<style scoped>
/* Same styles as before */
/* .voucher-container {
  display: flex;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
} */

.wizard-section {
  flex: 1;
  /* max-width: 500px; */
}

.voucher-selection {
  background: white;
  padding: 20px 0;
  border-radius: 8px;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}

.voucher-select,
.quantity-select {
  max-width: 200px;
}

.split-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
}

.footer {
  font-size: 0.9rem;
  color: #6c757d;
}

h2 {
  color: #2c3e50;
  font-size: 1.3rem;
}

h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
.voucher-image-section {
 height: 280px;
 display: flex;
 align-items: center;
 justify-content: center;
}

.voucher-image{
  /* width: 100%; */
  height: 100%;
  object-fit: contain;
}
@media (max-width: 768px) {
  .voucher-container {
    flex-direction: column;
  }

  .wizard-section {
    max-width: 100%;
  }
}
</style>
